module.exports = __webpack_public_path__ + "static/media/crown.0a67cef9.svg";